import { render, staticRenderFns } from "./OleMiss10PostLab.vue?vue&type=template&id=49292e88&scoped=true&"
import script from "./OleMiss10PostLab.vue?vue&type=script&lang=js&"
export * from "./OleMiss10PostLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49292e88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
